import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { cfAPI } from "../api";
import { createProgressHandler } from "../utils/createProgressHandler"; // Corrected file location

// Action Types
const CATEGORY_REQUEST = "CATEGORY_REQUEST";
const CATEGORY_ERROR = "CATEGORY_ERROR";
const CATEGORIES_FETCH = "CATEGORIES_FETCH";
const CATEGORY_FETCH = "CATEGORY_FETCH";
const CATEGORY_CREATE = "CATEGORY_CREATE";
const CATEGORY_EDIT = "CATEGORY_EDIT";
const CATEGORY_DELETE = "CATEGORY_DELETE";

// Download Action Types for categories
const CATEGORY_DOWNLOAD_START = "CATEGORY_DOWNLOAD_START";
const CATEGORY_DOWNLOAD_UPDATE = "CATEGORY_DOWNLOAD_UPDATE";
const CATEGORY_DOWNLOAD_FINISH = "CATEGORY_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/categories";

// Reusable action types object for consistency
const actionTypes = {
  fetches: {
    request: CATEGORY_REQUEST,
    success: CATEGORIES_FETCH,
    error: CATEGORY_ERROR,
  },
  fetch: {
    request: CATEGORY_REQUEST,
    success: CATEGORY_FETCH,
    error: CATEGORY_ERROR,
  },
  create: {
    request: CATEGORY_REQUEST,
    success: CATEGORY_CREATE,
    error: CATEGORY_ERROR,
  },
  update: {
    request: CATEGORY_REQUEST,
    success: CATEGORY_EDIT,
    error: CATEGORY_ERROR,
  },
  delete: {
    request: CATEGORY_REQUEST,
    success: CATEGORY_DELETE,
    error: CATEGORY_ERROR,
  },
  download: {
    request: CATEGORY_REQUEST,
    start: CATEGORY_DOWNLOAD_START,
    update: CATEGORY_DOWNLOAD_UPDATE,
    finish: CATEGORY_DOWNLOAD_FINISH,
    success: CATEGORIES_FETCH,
    error: CATEGORY_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  categories: [],
  category: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// Actions using the new handlers

export const FetchCategories = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const FetchCategory = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetch,
    null // No toast for a fetch
  );
};

export const CreateCategory = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, values),
    actionTypes.create,
    "Category Created"
  );
};

export const UpdateCategory = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, values),
    actionTypes.update,
    "Category Updated"
  );
};

export const DeleteCategory = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${id}`),
    actionTypes.delete,
    "Category Deleted"
  );
};

// Reducer with toasts removed and state logic updated
export const CategoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CATEGORY_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case CATEGORY_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case CATEGORY_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };
    case CATEGORY_REQUEST:
      return { ...state, loading: true };
    case CATEGORIES_FETCH:
      return {
        ...state,
        loading: false,
        error: "",
        categories: action.payload,
      };
    case CATEGORY_FETCH:
      return { ...state, loading: false, error: "", category: action.payload };
    case CATEGORY_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        categories: [...state.categories, action.payload],
      };
    case CATEGORY_EDIT:
      const updatedList = state.categories.map((category) =>
        category.id === action.payload.id ? action.payload : category
      );
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        category: action.payload,
        categories: updatedList,
      };
    case CATEGORY_DELETE:
      const newList = state.categories.filter(
        (s) => s.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        error: "",
        categories: newList,
      };
    case CATEGORY_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
